import React from 'react';
import { ArrowRight } from 'lucide-react';
import { BakeryEvent } from '../types/event';
interface EventRowProps {
  event: BakeryEvent;
  onSignup: (event: BakeryEvent) => void;
}
export function EventRow({
  event,
  onSignup
}: EventRowProps) {
  const date = new Date(`${event.date}T12:00:00`);
  const weekday = date.toLocaleDateString('sv-SE', {
    weekday: 'long'
  });
  const shortDate = `${date.getDate()}/${date.getMonth() + 1}`;
  return <article className="grid grid-cols-1 sm:grid-cols-[120px_1fr] gap-x-6 gap-y-3 bg-[#1C1917] rounded-2xl p-5 md:p-6" data-id="element-452" data-mp="1pqgwog8kkch4">
      <div className="flex sm:flex-col items-baseline sm:items-start sm:justify-center gap-2 sm:gap-0" data-id="element-453" data-mp="1kq1i5lcjwyxk">
        <span className="text-sm text-[#F5EDE3]/60 capitalize" data-id="element-454" data-mp="1fum874hnzn6f">{weekday}</span>
        <span className="text-3xl md:text-4xl font-extrabold text-[#FFB27A] leading-none tracking-tight" data-id="element-455" data-mp="1atgep4g6jvvu">
          {shortDate}
        </span>
      </div>

      <div className="min-w-0" data-id="element-456" data-mp="3vjnugrehqk2s">
        <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-2 mb-2" data-id="element-457" data-mp="3vidwe27n1bw5">
          <h3 className="text-xl md:text-2xl font-bold text-[#F5EDE3] leading-tight" data-id="element-458" data-mp="1umm6sp9v5vqk">
            {event.title}
          </h3>
          {(event.time || event.secondaryTime) && <div className="flex flex-wrap gap-2 shrink-0" data-id="element-459" data-mp="1km3i9h7ctr2b">
              {event.time && <span className="px-3 py-1 rounded-full bg-[#FF7A1A] text-[#1A0F08] text-sm font-bold whitespace-nowrap" data-id="element-460" data-mp="1plf1cwv718n2">
                  {event.time}
                </span>}
              {event.secondaryTime && <span className="px-3 py-1 rounded-full border border-[#FF7A1A] text-[#FFB27A] text-sm font-bold whitespace-nowrap" data-id="element-461" data-mp="1gmuowdg87v7a">
                  {event.secondaryTime}
                </span>}
            </div>}
        </div>

        <p className="text-[#F5EDE3]/80 leading-relaxed" data-id="element-462" data-mp="svfjucx2ezsc">{event.description}</p>

        {event.highlight && <p className="mt-4 rounded-xl bg-[#2A1D14] px-4 py-3 text-[#F5EDE3]/85 leading-relaxed" data-id="element-463" data-mp="wxsqd3jmz1q6">
            <span className="font-bold text-[#FF9A4D]" data-id="element-464" data-mp="2zkhm5bjhk9cd">
              {event.highlight.title}
            </span>{' '}
            – {event.highlight.text}
          </p>}

        {event.dropIn && !event.signup && <div className="mt-5 flex sm:justify-end" data-id="element-465" data-mp="2puxxfp93dl9l">
            <span className="inline-flex items-center px-5 py-2.5 rounded-full border border-[#FF7A1A] text-[#FFB27A] text-sm font-bold whitespace-nowrap" data-id="element-466" data-mp="2kvl9t2aeca5y">
              Drop in
            </span>
          </div>}

        {event.signup && <div className="mt-5 flex sm:justify-end" data-id="element-467" data-mp="3dksaa6tev9tu">
            <button onClick={() => onSignup(event)} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#FF7A1A] text-[#1A0F08] text-sm font-bold hover:bg-[#FF9A4D] transition-colors whitespace-nowrap focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FFB27A] focus-visible:ring-offset-2 focus-visible:ring-offset-[#1C1917]" data-id="element-468" data-mp="38kcwxf94q2bv">
              {event.ctaLabel ?? 'Boka plats'}
              <ArrowRight className="w-4 h-4" aria-hidden="true" data-id="element-469" data-mp="8nxycbvj5cok" />
            </button>
          </div>}
      </div>
    </article>;
}